<template>
  <div
    class="keyword-chip"
    :class="listMode ? 'd-block' : 'd-inline'"
    @click="toggleKeyword(keyword)"
  >
    <v-chip
      v-if="!isPlusButton"
      :id="getId"
      label
      :text-color="isKeywordSelected ? 'primary' : 'grey darken-3'"
      :outlined="isKeywordSelected"
      class="text mb-4"
      :class="{
        'keyword-chip-item-big': isBigMode,
        'primary-surface': isKeywordSelected,
        'text-l-small-regular': !isBigMode,
        'text-l-large-regular': isBigMode,
        clickable: currentUser && !isSpecialRequirement,
        'keyword-chip-item-break-line': !truncateText && isGreaterThanContainer,
        'keyword-chip-item': truncateText,
      }"
      :color="backgroundColor"
    >
      <span
        v-if="$breakpoint.tabletAndDown"
        :class="{ 'text-truncate': truncateText }"
      >
        {{ keyword }}
      </span>
      <v-tooltip
        v-if="$breakpoint.smallDesktopAndUp"
        top
      >
        <template #activator="{ on, attrs }">
          <span
            v-bind="attrs"
            :class="{ 'text-truncate': truncateText }"
            v-on="on"
            >{{ keyword }}</span
          >
        </template>
        <span>{{ keyword }}</span>
      </v-tooltip>

      <div v-if="!isSpecialRequirement">
        <ph-x
          v-if="isKeywordSelected && currentUser"
          class="ml-2"
          :class="{ clickable: currentUser }"
          weight="thin"
          size="18"
          color="var(--v-primary-base)"
        />
        <ph-plus
          v-if="!isKeywordSelected && currentUser"
          class="ml-2"
          :class="{ clickable: currentUser }"
          weight="thin"
          size="18"
          color="var(--v-grey-darken3)"
        />
      </div>
    </v-chip>
    <v-chip
      v-if="isPlusButton"
      label
      color="white"
      text-color="grey darken-3"
      class="keyword-chip-item text text-l-small-regular mb-4 clickable"
      @click="showMoreInterests"
    >
      +{{ keyword }} interests
    </v-chip>
  </div>
</template>

<script>
import { PhX, PhPlus } from 'phosphor-vue';
import { mapGetters } from 'vuex';
export default {
  components: { PhX, PhPlus },
  props: {
    keyword: {
      type: String,
      required: true,
    },
    userKeywords: {
      type: Array,
      default: () => [],
      validate: (value) => {
        return value.every((v) => typeof v === 'string');
      },
    },
    isPlusButton: {},
    listMode: {},
    isBigMode: {},
    truncateText: { default: true, type: Boolean },
    isSpecialRequirement: { type: Boolean, default: false },
    backgroundColor: { type: String, default: 'white' },
  },
  data: () => ({
    keywordId: null,
  }),
  computed: {
    ...mapGetters('auth', ['currentUser']),
    isKeywordSelected() {
      return this.findIfKeywordIsSelected();
    },
    getId() {
      return this.keywordId;
    },
    isGreaterThanContainer() {
      let keyword = document.querySelector('#' + this.keywordId);
      let container = document.querySelector('.keywords-default-container');
      return keyword?.clientWidth > container.clientWidth - 24;
    },
  },
  mounted() {
    this.keywordId = this.keyword?.replaceAll(' ', '');
  },
  methods: {
    toggleKeyword(keyword) {
      if (!this.currentUser || this.isSpecialRequirement) {
        return;
      }

      if (!this.userKeywords || !this.findIfKeywordIsSelected()) {
        this.$emit('subscribe-keyword', keyword);
      } else {
        this.$emit('unsubscribe-keyword', keyword);
      }
    },
    findIfKeywordIsSelected() {
      return this.userKeywords?.findIndex((k) => k === this.keyword) >= 0;
    },
    showMoreInterests() {
      this.$emit('click-plus-remainig');
    },
  },
};
</script>

<style scoped lang="scss">
.keyword-chip-item {
  height: 36px !important;
  margin-left: 1px;
}
.keyword-chip-item-break-line {
  white-space: initial;
  height: 56px !important;
}
.keyword-chip-item-big {
  height: 40px !important;
  margin-left: 1px;
}
.keyword-chip {
  padding-right: 10px;
}
.keyword-chip .keyword-chip-item.v-chip.primary-surface,
.keyword-chip .keyword-chip-item-break-line.v-chip.primary-surface {
  outline: var(--v-primary-base) solid 1px;
  border-color: var(--v-primary-base);
}
.keyword-chip .v-chip.v-chip--outlined.v-chip.v-chip {
  background: var(--v-primary-surface-base) !important;
}
</style>
